import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { tokenStore } from "../lib/tokenStore";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => tokenStore.getUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = tokenStore.getToken();
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        tokenStore.updateUser(r.data);
      }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password, remember = false) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      tokenStore.setSession(r.data.access_token, r.data.user, remember);
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (email, password, display_name, remember = false) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/register", { email, password, display_name });
      tokenStore.setSession(r.data.access_token, r.data.user, remember);
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
